import { treeItemStyles as fastTreeItemStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationTreeItemStyles = (context, definition) => css `
  ${fastTreeItemStyles(context, definition)}
  :host {
    --focus-stroke-width: 0;
    --tree-item-nested-width: 1em;
  }

  :host([selected])::after {
    height: calc(((var(--base-height-multiplier) + var(--density)) * var(--design-unit)) * 1px);
    width: 5px;
    top: 0;
    border-radius: 0;
  }

  .positioning-region {
    height: calc(((var(--base-height-multiplier) + var(--density)) * var(--design-unit)) * 1px);
  }
`;
